<template>
<div style="height:90%">
    <div ref="fadeWhenModelOpen" class="h-100">
        <div class="d-flex">
            <div class="search-bar-comm-style pt-2 col-md-6" style="display: block;">
                <input
                  type="text"
                  class="rounded text-light search-bar"
                  :placeholder="$t('Search screen')"
                  autocomplete="off" v-model="searchFilters.name" @input="updateScreensLstFromServer(false)"/>
                </div>
            <div id="DAM-learn_about_screens" class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
                <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                  <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
                </svg>{{$t('Learn about screens')}}</button>
                <!-- <button class="btn btn-outline-secondary m-2"  style="border: 1px solid #585858;" v-on:click="editCustomMetadata('screen-info')">Edit</button> -->
                <!-- <button class="btn btn-outline-primary m-2" v-on:click="changeToSelectedScreensTableComponent('add-screen')">Add</button> -->
            </div>
        </div>
        <div class="pl-4 h-100 pt-0 pr-4 pb-2 h-100" style="overflow: auto;">
            <table class="table-with-border table-scroll small-first-col" style="background: transparent">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 30%">{{$t('Name')}}</th>
                        <th style="width: 50%">{{$t('Field(s)')}}</th>
                        <th style="width: 10%"></th>
                    </tr>
                </thead>
                <tbody class="body-half-screen">
                    <tr v-for="key in screensList" :key="key._id" :id="key._id"  
                        @click="selectRow(key), changeToSelectedCustomKeyComponent('screen-info', key)"
                        :class="{activeclass: actveCustMetadata == key._id}"
                        class="comm-user-row show-delete-icon">
                        <!-- @dblclick="changeToSelectedCustomKeyComponent('screen-info', key)"  -->
                        <td class="text-left" style="text-transform: capitalize;">{{key.name }}</td>
                        <td class="text-left" style="text-transform: capitalize;">
                          <div>
                            <span> {{ getFieldNamesList(key.field_id_list) }}</span>
                            <a v-if="key.field_id_list.length > 3" class="view-more w-25" @click="changeToSelectedCustomKeyComponent('screen-info', key)"> + {{$t('More')}} ...</a>
                          </div>
                        </td>
                        <td>
                          <svg  @click.stop.prevent="changeToSelectedCustomKeyComponent('screen-info', key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                        </td>  
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <pagination
                v-model="page"
                :records="totalTags"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
            />
        </div>
    </div>
<component :is="selectedComponenet" @close="closeLearnAboutPanel"></component>
</div>
</template>

<script>

import { mapActions,mapGetters,mapMutations } from "vuex";
import Pagination from "vue-pagination-2";
import LearnAbout from "./LearnAboutScreens.vue";
import {NotifierConstants} from "../../components.constants.js";
 
export default {
  props:["selectedScreenId"],
  components:{
    pagination: Pagination,
    "learn-about":LearnAbout
  },
  data(){
    return {
      deletedFieldList:[],
      page: 1,
      totalPages: -1,
      totalTags: -1,
      perPage: -1,
      fieldsIdNameList:[],
      selectedRowDetails:{},
      actveCustMetadata:null,
      selectedComponenet:null,
      screensList: [],
      options:{chunk:5},
      searchFilters:{
        type:'all'
      }
    };
  },
  methods: {
    openLearnAboutPanel(){
      this.selectedComponenet = 'learn-about';
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    closeLearnAboutPanel(){
      this.selectedComponenet = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    paginate(page) {
      this.page = page;
      this.updateScreensLstFromServer(true);
    },
    changeToSelectedScreensTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedScreensTableComponent", compName, payload)
        },
    editCustomMetadata(comp){
      if(this.selectedRowDetails._id != undefined){
        this.changeToSelectedScreensTableComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select Field to edit");
        return false;
      }
    },
    selectRow(key){
      this.selectedRowDetails = key;
      this.actveCustMetadata = key._id;
    },
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    getFieldNamesList(fieldIdsList){
      let fieldsNameString =[];
      let exten = ""
      let limitC = 3;
      if(typeof fieldIdsList != "undefined" && fieldIdsList.length > 0){
        let i = 0;
        while(i < fieldIdsList.length){
          if(i>limitC){
            break;
          }
          let fieldName = ""
          let fieldDetails = this.fieldsIdNameList.filter((field_)=>field_._id == fieldIdsList[i]);
          if(typeof fieldDetails != "undefined" && fieldDetails.length == 1 && !this.deletedFieldList.includes(fieldIdsList[i])){
            fieldName = this.getCustomMetadataName(fieldDetails[0]);
          }else if(['Tags', 'Upload path', 'Catalogs', 'Description'].includes(fieldIdsList[i])){
            fieldName = fieldIdsList[i]
          }else{
            limitC = limitC+1;
          }
          if(fieldName.length > 0){
            fieldsNameString.push(fieldName);
          }
          i++;
        }
      }else{
        exten = "NONE"
      }
      return fieldsNameString.join(", ") + exten;
    },
    changeToSelectedCustomKeyComponent(compName, metadataKeyInfo){
      this.$emit("changeToSelectedCustomKeyComponent", compName, metadataKeyInfo)
    },
    updateScreensLstFromServer(isPageClick = false){
      let payload = {}
      let filterBy = {}
      if(isPageClick){
        filterBy['page'] = this.page
      }
      if(typeof(this.searchFilters.name) != 'undefined' &&
      this.searchFilters.name.trim().length > 0){
        filterBy.name = this.searchFilters.name
      }
      if(typeof(filterBy) != 'undefined'){
        payload.params = filterBy
      }
      this.getAllScreensFromServer(payload).then((data)=>{
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalTags = data["total_screens"];
        this.perPage = data["screens_per_page"];
        this.screensList = data.screens;
        this.selectedRowDetails = {}
      });
    },
    handleFieldsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let entry_info = notification.message
          if ([NotifierConstants.fieldRemovedNotification,NotifierConstants.fieldModifiedNotification].includes(notification.message_type)){
            setTimeout(() => {
              for(let s of this.screensList){
                if(s.field_id_list.includes(entry_info.custom_metadata_id)){
                  if(notification.message_type == NotifierConstants.fieldRemovedNotification &&
                    !this.deletedFieldList.includes(entry_info.custom_metadata_id)){
                    this.deletedFieldList.push(entry_info.custom_metadata_id)
                  }
                  this.refreshStartUpData();
                  this.updateScreensLstFromServer(true);
                  break;
                }
              }
            }, 100);
          }else if([NotifierConstants.fieldCreatedNotification,
                    NotifierConstants.screenModifiedNotification].includes(notification.message_type)){
            this.updateScreensLstFromServer(true);
          }
        }
      },
      refreshStartUpData(){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          this.fieldsIdNameList = this.getStartUpDataFromInCache()["custom_metadatas"];
        }
      },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("screens", ["getAllScreensFromServer"]),
  },
  created(){
     this.addWSEventListener({
            eventname:[NotifierConstants.fieldRemovedNotification,NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.screenModifiedNotification],
            callback:this.handleFieldsNotification,
            parent:"showScreens"})
    this.refreshStartUpData();
    this.updateScreensLstFromServer(false);
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldRemovedNotification,NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.screenModifiedNotification],
            callback:this.handleFieldsNotification,
            parent:"showScreens"})
  }
};
</script>

<style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $learn-about-text-color:#9a9620;

.activeNav{
    color: $text-color !important;
    font-size:15px;
    font-weight:500;
}

.activeclass {
  color: $active-blue;
}

.view-more{
  color: $text-color;
  margin-inline-start: 7px;
}

.view-more:hover{
  color: $active-blue;
}

.key-div{
  color:$dull-text-color;
}
.search-bar-comm-style {
  margin-top: 5px;
  .search-bar{
    background: $primary-background!important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    padding-inline-start: 12px;
    margin: 0;
    margin-inline-end: 3%;  
    border: $border-color !important;
    padding-bottom:2px;
  }
}

// .table-scroll {
//   /*width:100%; */
//   height: 100%;
//   display: block;
//   empty-cells: show;
//   border: none!important;
//   /* Decoration */
//   border-spacing: 0;
//   border: 1px solid;
//   thead {
//     color: $dull-text-color !important;
//     position: relative;
//     display: block;
//     width: 100%;
//   }
//   tbody {
//     height: calc(100% - 150px);
//     display: block;
//     position: relative;
//     width: 100%;
//     font-weight: 500;
//     overflow: auto;
//   }
// }


.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
      padding:5px;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
      height:40px;
      td{
        text-align: start;
        padding: 5px;
      }
    }
  }
}

.table{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
  }
}

// .table-scroll tr {
//   width: 100%;
//   display: flex;
//   height:50px;
// }

// .table-scroll td,
// .table-scroll th {
//   flex-basis: 100%;
//   flex-grow: 2;
//   display: block;
//   padding: 1rem;
//   text-align: start;
// }


.small-col {
  flex-basis: 10%;
}


.comm-user-row:hover {
  color: $active-blue;
  background: $bg-color-on-hover;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  height: calc(100% - 50px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}


.more-actions-div {
  position: absolute;
  height: 30px;
  width: 100px;
  padding: 6px;
  z-index: 99;
  border: $border-color;
  background: $primary-background;
  bottom: 0px;
  inset-inline-start:15%;
  ul {
    list-style-type: none;
    li {
      color: $text-color !important;
    }
    li:hover {
      color: $active-blue !important;
    }
  }
}

.border{
  border:$border-color !important;
}

.show-delete-icon:hover{
      position: relative;
      .parent-row-delete,  .parent-row-edit{
          visibility: visible;
      }
  }

  .parent-row-delete, .parent-row-edit{
      margin-inline-start: 3px;
      // position: absolute;
      // inset-inline-end :0px;
      z-index: 1;
      background: #525252;
      border: 1px solid #262626;
      width: 55px;
      height: 44px;
      padding: 12px;
      top: 0px;
      border-radius: 4px;
      visibility: hidden;
      color: #fff;
  }

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.activestatus {
  color: $active-green-color !important;
}

// //pagination
::v-deep {
.page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

.primary-btn-style{
    width: 100%;
    text-align: end;
    button{
      height: 35px;
      width: 70px;
      font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}


.learn-about-text-styles{
  width: 200px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}
</style>